export const MIME_TYPES = {
    JSON:       "application/json",
    PDF:        "application/pdf",
    CSV:        "text/csv",
    XLSX:      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    IMAGE_JPEG: "image/jpeg",
    VIDEO_MP4:  "video/mp4",
    VIDEO_WEBM: "video/webm",
};
